import cnames from 'classnames'

const InvoiceData = ({ amount, installmentId, installmentNumber, isDiscount, itemName, name }) => {
  const eventsDecrement = ['due', 'itemDeleted', 'refund', 'refundCreated', 'overdue']
  const eventsIncrement = ['itemCreated', 'paid']
  const isDecrementEvent = eventsDecrement.includes(name)
  const isIncrementEvent = eventsIncrement.includes(name)
  const adjustedDecrement = isDiscount ? isIncrementEvent : isDecrementEvent
  const adjustedIncrement = isDiscount ? isDecrementEvent : isIncrementEvent

  const totalClass = cnames({ 'amount-decrement text-danger': adjustedDecrement,
                              'amount-increment text-success': adjustedIncrement })

  return (
    <div className="invoice-data d-flex justify-content-between mt-2">
      <span>{installmentNumber || itemName}</span>

      <span>{installmentId}</span>

      <span className={totalClass}>{amount?.display}</span>
    </div>
  )
}

export default InvoiceData
